import { render, staticRenderFns } from "./MemberDashboard.vue?vue&type=template&id=1b81da9c&"
import script from "./MemberDashboard.vue?vue&type=script&lang=js&"
export * from "./MemberDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports